export enum EnableValveEnum {
  ON,
  OFF,
}
